"use client";
import { jsxs as o, jsx as e, Fragment as g } from "react/jsx-runtime";
import { useState as T } from "react";
import { VisuallyHidden as b, Icon as y } from "@zapier/design-system";
import { Carousel as k } from "@zapier/design-system-beta";
import { e as v } from "../../emitEvent-B5xAYp5K.mjs";
import { UserInteractionEventName as I } from "../../observability/tracking/trackingTypes.es.js";
const w = "_currentItem_7i00z_1", C = "_carousel_7i00z_17", N = "_mediaItemThumbnail_7i00z_23", P = "_videoThumbnail_7i00z_55", S = "_playIcon_7i00z_60", a = {
  currentItem: w,
  carousel: C,
  mediaItemThumbnail: N,
  videoThumbnail: P,
  playIcon: S
};
function _(s) {
  var r = s.src, n = s.isThumbnail;
  return n ? /* @__PURE__ */ o("div", { className: a.videoThumbnail, children: [
    /* @__PURE__ */ e("video", { src: "".concat(r, "#t=1"), disablePictureInPicture: !0, disableRemotePlayback: !0, muted: !0 }),
    /* @__PURE__ */ e("div", { className: a.playIcon, children: /* @__PURE__ */ e(y, { name: "actionPlayFill", size: 20, color: "PrimeWhite" }) })
  ] }) : /* @__PURE__ */ e("video", { src: r, controls: !0, disablePictureInPicture: !0, disableRemotePlayback: !0, controlsList: "nodownload", children: /* @__PURE__ */ e("track", { default: !0, kind: "captions", srcLang: "en", src: "" }) });
}
function E(s) {
  var r, n, m, d, t = s.mediaItems, u = T(0), l = u[0], f = u[1], h = function(i) {
    v(I.mediaSlideshowCarouselArrowClicked, {
      event_action: "click",
      option_selected: i
    });
  }, p = function(i) {
    v(I.mediaSlideshowItemSelected, {
      event_action: "click",
      option_selected: i.toString()
    });
  };
  return t && t.length > 0 ? /* @__PURE__ */ o("div", { children: [
    /* @__PURE__ */ e("div", { className: a.currentItem, id: "current-media-item", role: "tabpanel", "aria-labelledby": "media-item-".concat(l), children: ((r = t[l]) === null || r === void 0 ? void 0 : r.type) === "image" ? /* @__PURE__ */ e("img", { src: (n = t[l]) === null || n === void 0 ? void 0 : n.src, alt: ((m = t[l]) === null || m === void 0 ? void 0 : m.alt) || "", className: a.mainImage }) : /* @__PURE__ */ e(_, { src: ((d = t[l]) === null || d === void 0 ? void 0 : d.src) || "", isThumbnail: !1 }) }),
    t.length > 1 && /* @__PURE__ */ e(k, { elementWidth: 120, gap: 16, paddingBottom: 1, className: a.carousel, role: "tablist", "aria-label": "Media slides", onLeftArrowClick: function() {
      return h("left");
    }, onRightArrowClick: function() {
      return h("right");
    }, children: t.map(function(i, c) {
      return /* @__PURE__ */ o("button", { role: "tab", id: "media-item-".concat(c), "aria-controls": "current-media-item", className: a.mediaItemThumbnail, onFocus: function() {
        f(c), p(c);
      }, "aria-selected": l === c, children: [
        /* @__PURE__ */ o(b, { children: [
          "Thumbnail of ",
          i.type,
          " "
        ] }),
        i.type === "image" ? /* @__PURE__ */ e("img", { src: i.src, alt: i.alt || "", className: a.thumbnailImage }) : /* @__PURE__ */ o(g, { children: [
          /* @__PURE__ */ e(_, { src: i.src, isThumbnail: !0 }),
          i.alt && /* @__PURE__ */ e(b, { children: i.alt })
        ] })
      ] }, c);
    }) })
  ] }) : null;
}
export {
  E as default
};
//# sourceMappingURL=MediaSlideshow.es.js.map
